import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=5a5ed093&"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports